<template>
  <div :class="componentClassName">
    <a-page-heading>通話録音再生 </a-page-heading>
    <m-section>
      <m-action-card class="t-history-sf-recording__card" title="通話録音再生" icon="phone-call-history">
        <div v-if="showPlayButton">
          <m-audio-player v-show="showPlayer" :audio-url="audioURL" :autoplay="true" />
          <audio v-show="false" controls :src="audioURL">Your browser does not support the audio tag.</audio>
          <m-button-container variant="horizontal" class="t-history-sf-recording__action-button">
            <a-button
              v-show="!showPlayer && !loading"
              id="play"
              :inline="true"
              variant="round"
              color="grey"
              size="large"
              icon="play"
              label="再生"
              @click="handlePlayRecordingClick"
            />
            <a-button
              v-if="downloadable && companyID !== point && authInfo !== 'operator'"
              v-show="showPlayer"
              id="download"
              :inline="true"
              variant="round"
              color="grey"
              size="small"
              icon="download"
              label="ダウンロード"
              @click="handleDownloadRecordingClick"
            />
            <a-loading v-if="loading"></a-loading>
          </m-button-container>
        </div>
      </m-action-card>
    </m-section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import MAudioPlayer from '@/components/molecules/audio-player';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

import { PERMISSIONS_FRONTEND } from '@/libs/constants';

import { utils } from '@/common/utils.js';
import dayjs from 'dayjs';
import { DEFAULT_TIMEZONE } from '@/libs/constants';

export default {
  name: 't-history-sf-recording',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MButtonContainer,
    MAudioPlayer,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    //historyData: {
    //  type: Object,
    //  default: null,
    //},
    handleEditContact: {
      type: Function,
      default: () => {},
    },
    handleActionButtonClick: {
      type: Function,
      default: () => {},
    },
    //handleEditMemoClick: {
    //  type: Function,
    //  default: () => {},
    //},
    handleEditRecordingClick: {
      type: Function,
      default: () => {},
    },
    // handleDownloadRecordingClick: {
    //   type: Function,
    //   default: () => {},
    // },
    //handleCancelClick: {
    //  type: Function,
    //  default: () => {},
    //},
    handlePhoneCallClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      contact: {
        name: '',
        partner_number: '',
        email: '',
        company_name: '',
        street_address: '',
      },
      CallSid: '',
      agent_name: '',
      talk_time: '',
      billing_time: '',
      start_dt: '',
      memo: '',
      dialog_memo: '',
      selectedCompanyID: '',
      //companyID: '',
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      showPlayButton: false,
      helpDialogVisible: false,
      currentHelpMessageTitle: '',
      currentHelpMessageText: '',
      recording_url: null,
      showPlayer: false,
      loading: false,
      memoDialogVisible: false,
      audioURL: '',
      // #2423
      memoEditFlag: true,
      authInfo: this.$store.state.user.authInfo,
      // 通話履歴に紐づいたSalesforceのケースID
      sfCaseId: null,
      results: { channelTag: '', resultEndTime: '', alternatives: { transcript: '' } },
      showError: false,
      errorMessage: '',
      recording: null,
      defaultErrorMessage: `Something went wrong, please check the system's log for detail.`,
      timeout: [],
      isShowTranscript: false,
      time: '',
      modalFlg: '',
      textFlg: false,
      voiceToTextMode: false,
      voiceToTextOn: false,
      playRecordingModalVisible: false,
      selectedRow: {},
      audioURLs: [],
      start_time: 0,
      mediaData: null,
      recordingCbx: {},
      recordingUrl: null,
      voiceToTextStatus: null,
      status: this.$route.query.status,
      isVdxNum: true,
      modelValue: null,
      textEditMode: false,
      voicemessageFlag: false,
      textResultList: [],
      backupTextResultList: [],
      point: POINT,
      isExistsContactData: false, // 連絡先存在フラグ
      trialCompany: false,
      isMiddlePlay: false,
      silentTextMessage: messageContent.silentTextMessage,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-history-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
    playable() {
      // Max duration that playable 60 minutes
      const maxDuration = 60 * 60;
      const talk_time = this.talk_time;
      const times = talk_time.match(/\d+/g);
      const duration = parseInt(times[0]) * 60 + parseInt(times[1]);
      return duration <= maxDuration;
    },
    downloadable() {
      // #2705
      if (this.authInfo === 'operator') {
        return false;
      }
      return this.companyID !== POINT;
    },
    canVoiceToText() {
      return this.voiceToTextOn && this.companyID !== POINT;
    },
    canDeleteRecordings() {
      return this.companyID !== POINT && (this.authInfo === 'supervisor' || this.authInfo === 'manager');
    },
    canEditVoiceToText() {
      return this.companyID !== POINT;
    },
  },
  async created() {
    this.CallSid = this.$route.query.CallSid;
    const formDataTmp = {
      callSid: this.CallSid,
    };
    await this.getCallLogDetail(formDataTmp);

    if (this.contact.partner_number) {
      await this.fetchContactDataHandler(this.contact.partner_number);
    }
    await this.canShowPlayButtonCheck();

    this.checkVdxbNum(this.selectedCompanyID, this.agent_name);
    this.getFlags();
    this.getText();

    // For Trial
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.trialCompany = true;
    }
  },
  mounted() {
    // #2423
    /*
    if (PERMISSIONS_FRONTEND['HistoryDetail']) {
      if (!PERMISSIONS_FRONTEND['HistoryDetail'][this.authInfo]) {
        this.$router.push({ path: '/permission-denied' });
        return;
      }
    }
    */

    // #2423
    if ((this.authInfo === 'operator' || this.authInfo === 'soOperator') && this.companyID === POINT) {
      this.memoEditFlag = false;
    }
    window.scrollTo(0, 0);
  },
  methods: {
    resize() {
      this.height = 'auto';
      this.$nextTick(() => {
        this.height = this.$refs.area.scrollHeight + 'px';
      });
    },
    getCallLogDetail: async function (formDataTmp) {
      await this.postRequest('/callLogClient/getCallLogDetail', formDataTmp)
        .then(e => {
          if (e.status) {
            this.agent_name = this.$route.query.agent_name;
            this.talk_time = e.data[0].dispTime;
            this.start_dt = e.data[0].start_dt;
            this.billing_time = e.data[0].minuites + '分';
            this.contact.partner_number = this.formatPhoneNumberDisplay(e.data[0].partner_number);
            this.selectedCompanyID = e.data[0].companyID;
            this.memo = e.data[0].memo;
            this.recordingUrl = e.data[0].recordingUrl;
            this.voiceToTextStatus = e.data[0].voiceToTextStatus;
            if (
              !this.voiceToTextStatus ||
              this.voiceToTextStatus === 'textDeleted' ||
              this.voiceToTextStatus === 'textFailed' ||
              this.voiceToTextStatus === 'processing'
            ) {
              this.isShowTranscript = false;
            } else {
              this.isShowTranscript = true;
            }
          } else {
            this.showErrorModal(messageContent.fetchDataFailed('発着信履歴詳細'));
          }
        })
        .catch(er => {
          this.showErrorModal(messageContent.fetchDataFailed('発着信履歴詳細'));
        });
    },
    canShowPlayButtonCheck() {
      // #2423
      if (this.selectedCompanyID === POINT) {
        this.showPlayButton = false;
        return;
      }
      const formData = {
        // #2423
        //companyID: this.$store.state.user.companyID,
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.postRequest('/call-history/getrecordingdata', formData).then(e => {
        if (e.status) {
          // this.showPlayButton = e.hasRecordingUrl && this.playable;
          this.showPlayButton = !!e.hasRecordingUrl;
        }
      });
    },
    /*
    handleCancelClick() {
      const query = {
        type: this.$route.query.type,
        phonebook_name: this.$route.query.search_phonebook_name,
        agent_name: this.$route.query.search_agent_name,
        memo: this.$route.query.search_memo,
        start: this.$route.query.start,
        end: this.$route.query.end,
        page: this.$route.query.page,
        phone_number: this.$route.query.search_phone_number,
      };
      const params = { filter: this.$route.params.filter };
      if (this.companyID === POINT) {
        this.$router.push({ name: 'HistoryList', query: { companyID: this.selectedCompanyID, ...query }, params });
      } else {
        this.$router.push({ name: 'HistoryList', query, params });
      }
    },
    */
    fetchContactDataHandler: async function (contactID) {
      if (this.companyID === POINT) {
        await this.postRequest('/contactlist/getcontactdata', {
          contactID: contactID,
          companyID: this.selectedCompanyID,
        })
          .then(e => {
            if (e.session) {
              this.isExistsContactData = e.data && ['supervisor', 'manager'].includes(this.authInfo) ? true : false;
              this.contact.name = e.data.view_name;
              this.contact.partner_number = e.data.key;
              this.contact.email = e.data.mail;
              this.contact.company_name = e.data.companyName;
              this.contact.street_address = e.data.address;
              //e.data.memo
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            //console.log(err);
            //this.showErrorModal('電話帳検索中にエラーが発生しました。時間を空けて再度実行してください。');
          });
      } else {
        this.postRequest('/contactlist/getcontactdata', { contactID: contactID, companyID: this.companyID })
          .then(e => {
            if (e.session) {
              this.isExistsContactData = e.data ? true : false;
              this.contact.name = e.data.view_name;
              this.contact.partner_number = e.data.key;
              this.contact.email = e.data.mail;
              this.contact.company_name = e.data.companyName;
              this.contact.street_address = e.data.address;
              //e.data.memo
            } else {
              window.location.href = '/login';
            }
          })
          .catch(err => {
            //console.log(err);
            //this.showErrorModal('電話帳検索中にエラーが発生しました。時間を空けて再度実行してください。');
          });
      }
    },
    formatPhoneNumberDisplay(pn) {
      return String(pn).replace('+81', '0');
    },
    handleEditMemoClick() {
      if (!this.hasSpecialCharacterInString(this.dialog_memo)) {
        const lengthCheck = this.memoLengthCheck(this.dialog_memo);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return;
        }

        // 先頭に改行コードがあれば消去する
        while (this.dialog_memo.match(/^\n/)) {
          this.dialog_memo = this.dialog_memo.replace(/^\n/, '');
        }

        this.changed_dialog_memo = this.dialog_memo.replace(/\n/g, '%%n%%');

        this.postRequest('/callLogClient/setmemo', {
          CallSid: this.CallSid,
          memo: this.changed_dialog_memo,
          selectedCompanyID: this.selectedCompanyID,
        })
          .then(e => {
            if (e.status) {
              //保存完了
              this.modalFlg = 'saveMemoSuccess';
              this.showInfoModal('メモを保存しました。');
              this.memoDialogVisible = false;
              this.memo = this.dialog_memo;
            }
          })
          .catch(err => {
            this.showErrorModal('メモの保存に失敗しました。');
            //console.log(err);
          });
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    async getChunk(index, start) {
      //const res = await fetch(`${this.recording_url}?index=${index}&start=${start}`, {
      const tCompanyID = this.companyID === POINT ? this.selectedCompanyID : this.companyID;
      const res = await fetch(`${this.recording_url}?index=${index}&start=${start}&companyID=${tCompanyID}`, {
        method: 'GET',
      });
      if (res.status !== 200) throw messageContent.recordingNotFound;
      const isLastChunk = res.headers.get('Last-Chunk');
      const loadedSize = res.headers.get('Loaded-Size');
      const blob = await res.blob();
      return { blob, isLastChunk, loadedSize };
    },
    async playRecording() {
      try {
        this.loading = true;
        const segments = [];
        let loadedSize = 0;
        let [isLastChunk, i] = [null, 0];
        while (isLastChunk !== 'true') {
          const chunk = await this.getChunk(i, parseInt(loadedSize));
          const buffer = await chunk.blob.arrayBuffer();
          isLastChunk = chunk.isLastChunk;
          loadedSize = chunk.loadedSize;
          segments.push(buffer);
          i++;
        }
        this.loading = false;
        this.showPlayer = true;
        const length = segments.reduce((size, segment) => {
          return size + segment.byteLength;
        }, 0);
        const mediaData = new Uint8Array(length);
        let pos = 0;
        for (let i = 0; i < segments.length; ++i) {
          mediaData.set(new Uint8Array(segments[i]), pos);
          pos += segments[i].byteLength;
        }
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        const audioBlob = new Blob([mediaData.buffer], { type: 'audio/wav' });
        const url = window.URL.createObjectURL(audioBlob);
        const audioElem = document.querySelector('audio');
        audioElem.src = url;
        audioElem.onload = evt => {
          URL.revokeObjectURL(url);
        };
        this.audioURL = url;
      } catch (e) {
        this.loading = false;
        this.showErrorModal(messageContent.recordingNotFound);
      }
    },
    handlePlayRecordingClick() {
      const formData = {
        // #2423
        //companyID: this.$store.state.user.companyID,
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.loading = true;
      this.postRequest('/call-history/getrecordingdata', formData)
        .then(e => {
          this.loading = false;
          if (e.status) {
            if (e.publicURL) {
              this.recording_url = e.publicURL;
              // this.showPlayer = true;
            } else {
              this.recording_url = `${location.origin}/Recordings/${e.urlPartial}`;
              // this.showPlayer = true;
            }
            // window.open(this.recording_url, "_blank");
            this.playRecording();
          }
        })
        .catch(() => {
          this.loading = false;
          this.showErrorModal(messageContent.requireTry('音声ファイルのダウンロード'));
        });
    },
    // eslint-disable-next-line require-await
    handleDownloadRecordingClick: async function () {
      const link = document.createElement('a');
      link.href = this.audioURL;
      link.download = `${this.start_dt.replace(/[^0-9]/g, '')}.wav`;
      link.click();
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleCloseHelpDialog() {
      this.helpDialogVisible = false;
    },
    handleRecordingHelpClick() {
      this.helpDialogVisible = true;
      this.currentHelpMessageTitle = messageContent.recordingHelpMessageTitle;
      this.currentHelpMessageText = messageContent.recordingHelpMessageContent;
    },
    async getVoiceToTextFlg() {
      await this.postRequest('/callLogClient/search', { companyID: this.selectedCompanyID })
        .then(e => {
          if (e.status === 'success') {
            this.voiceToTextMode = e.data['voiceToTextFlg'];
            this.voiceToTextOn = e.data['voiceToTextOn'];
          }
        })
        .catch(error => {
          console.error(error);
          this.voiceToTextMode = false;
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.callLogDownloadError);
        });
    },
    async getText() {
      const formData = {
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
      };
      // Spannerから音声テキスト化結果を取得している
      await this.postRequest('/voicetotext/gettext', formData)
        .then(e => {
          if (e.status === 'success') {
            if (e.text_result_list) {
              this.textFlg = true;
              this.textResultList = e.text_result_list;
              this.backupTextResultList = JSON.parse(JSON.stringify(this.textResultList));
              this.authInfo = e.authInfo;
            } else {
              this.textFlg = false;
            }
          }
          // 音声テキスト化モードを確認し、表示/非表示を切り替えている
          this.getVoiceToTextFlg();
        })
        .catch(error => {
          console.error(error);
          this.voiceToTextMode = false;
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.failDownloadText);
        });
    },
    time_convert(num) {
      const m = Math.floor(num / 60);
      const hours = ('0' + Math.floor(m / 60)).slice(-2);
      const seconds = ('0' + Math.floor(num % 60)).slice(-2);
      const minutes = ('0' + Math.floor(m % 60)).slice(-2);
      return `${hours}:${minutes}:${seconds}`;
    },
    confirmDeleteText() {
      this.modalFlg = 'confirmDelete';
      this.showModal(messageContent.confirmDelteText);
    },
    showModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    downloadCSV() {
      let csv = 'ユーザー名,通話開始からの経過時間,通話内容\n';
      let u;
      this.textResultList.forEach((textResult, i) => {
        if (textResult.channelTag === 2) {
          u = 'オペレーター';
        } else {
          u = 'ユーザー';
        }
        if (textResult.transcript) {
          csv += `${u},${this.time_convert(textResult.startTime)},${textResult.transcript}\n`;
        }
      });
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, csv], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      const now = dayjs().tz(DEFAULT_TIMEZONE);
      const year = now.format('YYYY');
      const month = now.format('MM');
      const hour = now.format('HH');
      const min = now.format('mm');
      const sec = now.format('ss');
      const file_name = `CCCtext_${year}${month}${hour}${min}${sec}`;
      anchor.download = file_name + '.csv';
      anchor.href = url;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    },
    doStartRecording() {
      this.isMiddlePlay = false;
      this.start_time = 0;
      this.playRecordingModalVisible = true;
      if (this.audioURLs[this.selectedRow.recordingUrl]) {
        this.playRecording();
        return;
      }
      const formData = {
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.loading = true;
      this.postRequest('/call-history/getrecordingdata', formData)
        .then(e => {
          this.loading = false;
          if (e.status) {
            if (e.publicURL) {
              this.recording_url = e.publicURL;
            } else {
              this.recording_url = `${location.origin}/Recordings/${e.urlPartial}`;
            }
            this.playRecording();
          }
        })
        .catch(error => {
          console.error(error);
          this.modalFlg = 'error';
          this.loading = false;
          this.showErrorModal(messageContent.requireTry('音声ファイルのダウンロード'));
        });
    },
    doStartRecordingInMiddle(start_time) {
      this.isMiddlePlay = true;
      this.start_time = start_time;
      this.playRecordingModalVisible = true;
      if (this.audioURLs[this.selectedRow.recordingUrl]) {
        this.playRecording();
        return;
      }
      const formData = {
        companyID: this.selectedCompanyID,
        userID: this.$store.state.user.userID,
        callSid: this.CallSid,
      };
      this.loading = true;
      this.postRequest('/call-history/getrecordingdata', formData)
        .then(e => {
          this.loading = false;
          if (e.status) {
            if (e.publicURL) {
              this.recording_url = e.publicURL;
            } else {
              this.recording_url = `${location.origin}/Recordings/${e.urlPartial}`;
            }
            this.playRecording();
          }
        })
        .catch(error => {
          console.error(error);
          this.modalFlg = 'error';
          this.loading = false;
          this.showErrorModal(messageContent.requireTry('音声ファイルのダウンロード'));
        });
    },
    async deleteText() {
      const formData = {
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
      };
      // SpannerとGCSから音声テキスト化結果を削除している
      await this.postRequest('/voicetotext/deletetext', formData)
        .then(res => {
          this.transcriptList = [];
          this.isShowTranscript = false;
          this.handleCloseModal();
        })
        .catch(error => {
          console.error(error);
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.requireTry('音声テキスト化ファイル削除)'));
        });
    },
    confirmDeleteRecording() {
      this.modalFlg = 'confirmDeleteRecording';
      this.showModal(messageContent.confirmDeleteRecording);
    },
    deleteRecording() {
      this.recordingCbx[this.CallSid] = true;
      // GCSから通録と音声テキスト化結果、Spannerから音声テキスト化を削除している
      this.postRequest('/callLogClient/deleteRecording', {
        CallSids: this.recordingCbx,
        companyID: this.selectedCompanyID,
      })
        .then(res => {
          if (res.status === 'success') {
            this.recordingUrl = null;
            this.handleCloseModal();
          } else {
            this.modalFlg = 'error';
            this.showErrorModal(messageContent.requireTry('通話録音の削除'));
          }
        })
        .catch(err => {
          console.log(err);
          this.modalFlg = 'error';
          this.showErrorModal(messageContent.requireTry('通話録音の削除'));
        });
    },
    confirmDoVoiceToText() {
      if (this.voiceToTextOn) {
        this.modalFlg = 'confirmDoVoiceToText';
        this.showModal(messageContent.confirmDoVoiceToText);
      } else if (this.trialCompany) {
        this.modalFlg = 'notifyTrialUserCanNotUseThisFunction';
        this.showInfoModal(messageContent.notifyTrialUserCanNotUseThisFunction());
      } else {
        this.modalFlg = 'requestDoVoiceToTextSetting';
        this.showInfoModal(messageContent.requestDoVoiceToTextSetting);
      }
    },
    doVoiceToText() {
      this.voiceToTextStatus = 'processing';
      const formData = {
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
        callSid: this.CallSid,
      };
      // 通録ファイルをGCSにアップロードしている、その結果、音声テキスト化される
      this.postRequest('/voicetotext/createWavFile', formData);
      this.handleCloseModal();
    },
    /*
    handleEditCallerInformation() {
      this.$router.push({
        path: '/contactlist/edit',
        query: {
          contactID: this.contact.partner_number,
          companyID: this.selectedCompanyID,
          fromHistoryDetails: true,
          CallSid: this.CallSid,
          search_phonebook_name: this.$route.query.search_phonebook_name,
          search_agent_name: this.$route.query.search_agent_name,
          search_memo: this.$route.query.search_memo,
          start: this.$route.query.start,
          end: this.$route.query.end,
          type: this.$route.query.type,
          page: this.$route.query.page,
          search_phone_number: this.$route.query.search_phone_number,
          status: this.$route.query.status,
          agent_name: this.$route.query.agent_name,
        },
      });
    },
    */
    async checkVdxbNum(companyId, telNum) {
      const formData = {
        companyId: companyId,
        telNum: telNum,
      };
      await this.postRequest('/voicetotext/checkVdxbNum', formData).then(res => {
        this.isVdxNum = res.result;
      });
    },
    emitEvent(modelValue) {
      this.modelValue = modelValue;
    },
    changeTextEditMode() {
      // 編集ができるように、入力フォームに切り替わる
      this.textEditMode = true;
    },
    cancelTextEditMode() {
      this.textResultList = JSON.parse(JSON.stringify(this.backupTextResultList));
      this.textEditMode = false;
    },
    handleTextEdit() {
      for (let i = 0; i < this.textResultList.length; ++i) {
        if (this.hasSpecialCharacterInString(this.textResultList[i].transcript)) {
          this.modalFlg = 'invalidCharactor';
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return;
        }
      }
      const formData = {
        textResultList: this.textResultList,
        recordingUrl: this.recordingUrl,
        companyID: this.selectedCompanyID,
      };
      // Spannerの音声テキスト化結果をアップデートしている
      this.postRequest('/voicetotext/updateTexts', formData).then(res => {
        this.backupTextResultList = JSON.parse(JSON.stringify(this.textResultList));
        this.textEditMode = false;
      });
    },
    doDeleteText(index) {
      // HTML上のテキストを削除している、Spannerに保存はしていない
      this.textResultList.splice(index, 1);
    },
    getFlags() {
      const formData = {
        callSid: this.CallSid,
        companyId: this.selectedCompanyID,
      };
      // 留守録があるか確認している
      this.postRequest('/voicetotext/getFlags', formData).then(res => {
        this.voicemessageFlag = res.result[0].voicemessageFlag;
      });
    },
  },
};
</script>
